import { styled } from '@mui/system';
import Typography from '@mui/material/Typography';

// types and classes
import type { QuestionInstanceFormError } from './types';

const ErrorDiv = styled('div')(({ theme }) => ({
  color: theme.palette.error.main,
}));

const ErrorUl = styled('ul')(() => ({
  listStyle: 'disc inside none',
}));

type DisplayFormErrorsProps = {
  formError: QuestionInstanceFormError;
};

export function DisplayFormErrors({ formError }: DisplayFormErrorsProps) {
  const allErrorStrings: Array<string> = !formError
    ? []
    : typeof formError === 'string'
    ? [formError]
    : Object.values(formError).reduce((acc: Array<string>, errorList) => {
        return [...acc, ...errorList];
      });

  if (allErrorStrings.length === 0) {
    return null;
  }
  if (allErrorStrings.length === 1) {
    return (
      <Typography sx={{ color: 'error.main' }}>{allErrorStrings[0]}</Typography>
    );
  }
  if (allErrorStrings.length > 1) {
    return (
      <ErrorDiv>
        <Typography sx={{ color: 'inherit' }}>
          There were errors with the form:
        </Typography>
        <ErrorUl>
          {allErrorStrings.map((errorString) => (
            <li key={errorString}>{errorString}</li>
          ))}
        </ErrorUl>
      </ErrorDiv>
    );
  }
  return null;
}
